const registerPlugin = (registrator) => {
    return (element, plugins, app) => registrator(element, plugins, app);
};
export default registerPlugin;
